import { applyDecorators } from '@nestjs/common';
import { ApiProperty, ApiPropertyOptional, ApiPropertyOptions } from '@nestjs/swagger';
import { Type } from 'class-transformer';
import { IsDate, IsOptional, MinDate } from 'class-validator';

import { INVALID_DATE, INVALID_LIMIT_VALUE } from '../constants';
import { BaseDecoratorOptions } from '../types';

type PropertyDateParams = {
  minDate?: Date;
} & BaseDecoratorOptions<string>;

export function ApiPropertyDate({ isOptional, minDate, ...options }: PropertyDateParams = {}): PropertyDecorator {
  const propertyOptions: ApiPropertyOptions = { type: Date, example: '2022-01-11T17:28:44.079Z', ...options };

  return applyDecorators(
    ...(isOptional ? [IsOptional(), ApiPropertyOptional(propertyOptions)] : [ApiProperty(propertyOptions)]),
    IsDate({ message: INVALID_DATE }),
    ...(minDate ? [MinDate(minDate, { message: INVALID_LIMIT_VALUE, context: { minValue: minDate } })] : []),
    Type(() => Date),
  );
}
